import * as React from 'react';
import { EditableEntry, Entry, ReadableEntry } from './entry';
import { EntryTitle } from './entryTitle';
import '../styles/editorPane.css';

interface EditorPaneProps {
  changeContentHandler: (value: string) => void;
  changeShortHandler: (value: string) => void;
  entry: Entry | null;
  isDirty: boolean;
}

export const EditorPane: React.SFC<EditorPaneProps> = (props) => {
  if (!props.entry) {
    return null;
  }

  return (
    <div className="editorPane">
      <div className="topNav">
        <EntryTitle
          text={props.entry.short}
          onChange={props.changeShortHandler}
        />
      </div>
      <div className="content">
        <EditableEntry
          entry={props.entry}
          isDirty={props.isDirty}
          onChange={props.changeContentHandler}
        />
        <ReadableEntry
          entry={props.entry}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/editorPane.tsx